class BaseService {
  readonly baseUrl: string;
  readonly awsUrl: string;
  readonly progressBaseUrl: string;
  readonly memberId: string;
  protected servicePath = "";

  constructor() {
    // this comparison be needed if we want to test localhost-ed app
    // on random devices: phones or tablets - located in same wifi space
    // basically we connect to same ip with another port (where our backend placed)
    const { protocol, hostname } = window.location;
    this.baseUrl = process.env.REACT_APP_API_BASE_URL || `${protocol}//${hostname}:8000`;
    this.awsUrl = process.env.REACT_APP_ASSESSMENTS_LAMBDA_URL || ''
    this.progressBaseUrl = process.env.REACT_APP_API_PROGRESS_URL || `${protocol}//${hostname}:8001`
    this.memberId = process.env.REACT_APP_MEMBER_ID || "1"
  }

  protected getBaseUrl() {
    return this.baseUrl;
  }

  protected getAwsBaseUrl() {
    return this.awsUrl;
  }

  protected getProgressUrl() {
    return this.progressBaseUrl;
  }

  protected getUrl(...segments: (string | number | boolean)[]): string {
    const basePaths = [this.baseUrl, this.servicePath];
    return basePaths.concat(segments.map(String)).join("/");
  }
}

export default BaseService;
